module.exports = __webpack_public_path__ + "img/east-timor.c207a7ae.png";